import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import {
    AppBar, Button, Checkbox, CircularProgress, FormControlLabel, Grid, makeStyles, Typography, Link, Icon,
    Accordion, AccordionSummary, AccordionDetails
} from '@material-ui/core';

import { BasicConfirmDialog } from '../../../shared/components/BasicConfirmDialog';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { AuthContext } from '../../Authentication/AuthContext';
import { HomeContext } from '../../Home/HomeContext';
import { NewsStatus } from '../enum/NewsStatus';
import { ErrorStatus } from '../../../shared/enum/ErrorStatus';
import { EditedNewsFieldModel } from '../../../Models/EditedNewsFieldModel';
import { NewsModel } from '../../../Models/NewsModel';
import { VehicleDictionaryModel } from '../../../Models/VehicleDictionaryModel';
import { InfluencerContext } from '../NewsContext';
import NewsData from '../components/NewsData';
import EditedNewsFieldService from '../../../Services/EditedNewsFieldService';
import NewsService from '../../../Services/NewsService';
import VehicleDictionaryService from '../../../Services/VehicleDictionaryService';
import { JournalistModel } from '../../../Models/JournalistModel';
import { ClassificationModel, classificationModelInitial } from '../../../Models/ClassificationModel';
import ClassificationService from '../../../Services/ClassificationService';
import { RestoreClassification } from '../components/RestoreClassification';
import { ClassificationStatus } from '../enum/ClassificationStatus';
import { Alert } from '@material-ui/lab';
import { NewsLoadingContext } from '../NewsLoadingContext';
import { LoadingStatus } from '../enum/LoadingStatus';
import { InfluencerModel } from '../../../Models/InfluencerModel';
import InfluencerService from '../../../Services/InfluencerService';
import NewsDataQuestions from '../components/NewsDataQuestions';

export interface INewsClassificationProps {
    spreadsheetId: number,
    openList: boolean,
    setOpenList: (open: boolean) => void
}

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
    },
    buttonsTop: {
        textTransform: 'initial',
        color: theme.palette.primary.main,
    },
    toolbar: {
        marginTop: '64px',
        padding: '8px',
        backgroundColor: '#F0F1F1',
    },
    loading: {
        minHeight: '80vh'
    },
    gridContainer: {
        marginTop: theme.spacing(3),
        maxWidth: '1800px',
        padding: theme.spacing(1)
    },
    gridContainerClient: {
        maxWidth: '1800px',
        padding: theme.spacing(3)
    },
    gridContainerText: {
        marginTop: '8px',
        maxWidth: '630px',
        padding: theme.spacing(1),
        height: 'calc(100vh - 100px)'
    },
    gridEditNews: {
        marginTop: theme.spacing(3)
    },
    text: {
        padding: theme.spacing(2)
    },
    clickHereText: {
        paddingBottom: theme.spacing(2)
    },
    clickHereLink: {
        textDecoration: 'underline',
        color: theme.palette.primary.dark,
        fontWeight: 'bold',
        '&:hover': {
            cursor: 'pointer'
        }
    }
}));

export default function NewsClassification({ spreadsheetId, openList, setOpenList }: INewsClassificationProps) {
    const classes = useStyles();

    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);
    const newsContext = React.useContext(InfluencerContext);
    const newsLoadingContext = React.useContext(NewsLoadingContext);

    const [loading, setLoading] = React.useState<boolean>(false);
    const [showConfirmExit, setShowConfirmExit] = React.useState<boolean>(false);

    const [copyClassification, setCopyClassification] = React.useState<InfluencerModel | null>(null);

    const [hasNotError, setHasNotError] = React.useState<boolean>(false);

    React.useEffect(() => {
        newsContext.setClassification(classificationModelInitial);

        // fetchNews();
    }, [newsContext.newsCurrentId]);

    React.useEffect(() => {
        if (newsContext.errorDataStatus == ErrorStatus.HAS_NOT_ERROR && newsContext.errorCategorizationStatus == ErrorStatus.HAS_NOT_ERROR) {
            setHasNotError(true);
        }
        else if ((newsContext.errorDataStatus == ErrorStatus.HAS_ERROR ||
            newsContext.errorCategorizationStatus == ErrorStatus.HAS_ERROR) &&
            newsContext.errorAtLeastOneCategorizationStatus !== ErrorStatus.HAS_ERROR) {
            homeContext.showError('Ops.. existem campos com preenchimento inválido. Por favor, verifique os campos acima e tente novamente.');
        }
    }, [newsContext.errorDataStatus, newsContext.errorCategorizationStatus]);

    React.useEffect(() => {
        fetchQuestions();
        fetchInfluencerStatus();
    }, [newsContext.newsCurrentId]);

    const fetchQuestions = () => {
        newsContext.newsCurrentId &&
            InfluencerService.getAllQuestions().then((response) => {
                const allQuestions = response.data;
                const newQuestions = allQuestions.map((question: any) => {
                    return { ...question, value: newsContext.news.answers.filter(el => el.id == question.id)[0]?.value };
                });
                const updatedQuestions = { ...newsContext.questions };
                const hasQuestions = updatedQuestions[newsContext.newsCurrentId!] &&
                    updatedQuestions[newsContext.newsCurrentId!].find((item: any) => item.value !== undefined);
                if (!hasQuestions && updatedQuestions) {
                    updatedQuestions[newsContext.newsCurrentId!] = newQuestions;
                    return newsContext.setQuestions(updatedQuestions);
                }
            });
    };

    const fetchInfluencerStatus = () => {
        newsContext.newsCurrentId &&
            InfluencerService.getStatusClassification().then((response) => {
                const updatedStatusClassification = { ...newsContext.statusClassification };
                const hasStatusClassification = updatedStatusClassification[newsContext.newsCurrentId!];
                if (!hasStatusClassification && updatedStatusClassification) {
                    updatedStatusClassification[newsContext.newsCurrentId!] = response.data;
                    updatedStatusClassification[newsContext.newsCurrentId!]['statusClassificacao'] = newsContext.news.statusClassificacao;
                    return newsContext.setStatusClassification(updatedStatusClassification);
                }
            });

    };

    const handleClickSave = () => {
        const hasBoardError = haStatusBoardError();
        const hasError = hasQuestionError();
        if (!hasError && !hasBoardError) {
            return saveClassification();
        }
        else {
            return homeContext.showError('Ops.. existem campos com preenchimento inválido. Por favor, verifique os campos acima e tente novamente.');
        }
    };

    const handleClickCheck = () => {
        return reviserInfluencer();
    };

    const hasQuestionError = () => {
        const questions = newsContext.questions[newsContext.newsCurrentId!];
        const hasValue = questions.find((question: any) => !question.value && question.tipo == 2);
        return hasValue;
    };
    const haStatusBoardError = () => {
        const board = newsContext.statusClassification[newsContext.newsCurrentId!].statusClassificacao;
        if (!board) {
            return true;
        }
        return false;
    };


    const reviserInfluencer = () => {
        homeContext.setOpenLoadingDialog(true);
        const influencerData = {
            StatusRevisor: newsContext.news.statusRevisor,
        };
        InfluencerService.putStatusRevisor(newsContext.news.id, influencerData)
            .then(() => {
                homeContext.setOpenLoadingDialog(false);
                finishSaveAndCallNextNews();
            })
            .catch((error: AxiosError) => {
                homeContext.setOpenLoadingDialog(false);
                homeContext.showError('Erro ao Revisar influenciador. <br/>', error);
            });
        return;
    };

    const saveClassification = () => {

        const localDate = new Date(newsContext.news.validadeAnalise);
        const utcDate = new Date(localDate.getTime() - (localDate.getTimezoneOffset() * 60000));
        const utcDateString = utcDate.toISOString();

        homeContext.setOpenLoadingDialog(true);
        const influencerData = {
            id: newsContext.news.id,
            dataAnalise: newsContext.news.dataAnalise,
            validadeAnalise: utcDateString,
            usuario: newsContext.news.usuario,
            url_perfil: newsContext.news.url_perfil,
            id_solicitante: newsContext.news.id_solicitante,
            finalidade: newsContext.news.finalidade,
            rtb: newsContext.news.rtb,
            preavaliacao: newsContext.news.preavaliacao,
            marca: newsContext.news.marca,
            questions: newsContext.questions[newsContext.news.id],
            nome: newsContext.news.nome,
            statusClassificacao: newsContext.statusClassification[newsContext.news.id].statusClassificacao,
            ObservacaoStatus: newsContext.news.observacaoStatus,
            ObjetivoUso: newsContext.news.objetivoUso,
            Campanha: newsContext.news.campanha,
            PagoOrganico: newsContext.news.pagoOrganico,
            TipoPerfil: newsContext.news.tipoPerfil,
        };
        InfluencerService.putClassification(influencerData.id, influencerData)
            .then(() => {
                homeContext.setOpenLoadingDialog(false);
                finishSaveAndCallNextNews();
            })
            .catch((error: AxiosError) => {
                homeContext.setOpenLoadingDialog(false);
                homeContext.showError('Erro ao atualizar influenciador. <br/>', error);
            });
        return;
    };

    const changeInfluencer = async (classification?: ClassificationModel) => {
        const nextId = newsContext.newsCurrentId! + 1;
        let found = -1;
        if (newsContext.tabListSelected == 0)
            found = newsContext.newsList.findIndex(x => x.id == nextId);
        else if (newsContext.tabListSelected == 1)
            found = newsContext.listNewsPending.findIndex(x => x.id == nextId);

        if (found !== -1) {
            newsContext.setNews(newsContext.newsList[found]);
            newsContext.setNewsIndex(found);

            newsContext.setNewsCurrentId(nextId);
            newsContext.setKeepData(false);
        }
    };

    const fetchInfluencer = async () => {
        InfluencerService.InfluencerService(homeContext.spreadsheetId!)
            .getAll()
            .then((res: AxiosResponse) => {
                newsContext.setNewsList(res.data);
            })
            .catch((error: AxiosError) => { homeContext.showError('', error); });
    };

    const finishSaveAndCallNextNews = async (classification?: ClassificationModel) => {
        homeContext.setAlertProps({
            message: getAlertMessage(classification),
            severity: 'success',
            open: true
        });
        fetchInfluencer();
        changeInfluencer();
    };

    const getAlertMessage = (classification?: ClassificationModel) => {
        if (classification) {
            let idMessage = '';
            if (classification.metricId != '')
                idMessage = `ID Metric: ${classification.metricId}`;
            else
                idMessage = `ID Plataforma: ${classification.id}`;

            return (
                <>
                    <Typography variant="caption">
                        A classificação do Influenciador foi salva com sucesso! <br />
                        <strong>{idMessage}</strong>
                    </Typography>
                </>
            );
        }
        else
            return 'A classificação do Influenciador foi salva com sucesso!';
    };

    const createAndSaveEditedNewsFields = async (initialStateOfNews: NewsModel, currentStateOfClassification: ClassificationModel) => {

        const editedNewsFields: EditedNewsFieldModel[] = [];

        createEditedNewsField(editedNewsFields, initialStateOfNews.title, currentStateOfClassification.publicationTitle, 'Título');
        createEditedNewsField(editedNewsFields, initialStateOfNews.clipperLink, currentStateOfClassification.clipperLink, 'Link da Clipadora');
        createEditedNewsField(editedNewsFields, initialStateOfNews.newsLink, currentStateOfClassification.originalLink, 'Link Externo');
        createEditedNewsField(editedNewsFields, initialStateOfNews.publishDate, currentStateOfClassification.publicationDate, 'Data da Publicação');
        createEditedNewsField(editedNewsFields, initialStateOfNews.vehicleCodeMetric, currentStateOfClassification.vehicle?.codeMetric, 'Veículo da Notícia');
        createEditedNewsField(editedNewsFields, initialStateOfNews.centimeter, currentStateOfClassification.centimeter, 'Centimetragem');
        createEditedNewsFieldJournalist(editedNewsFields, initialStateOfNews.journalistSpreadsheetName ? initialStateOfNews.journalistSpreadsheetName : '', currentStateOfClassification.journalists, 'Jornalistas');

        saveEditedNewsFields(editedNewsFields);
    };

    const createEditedNewsField = (editedNewsFields: EditedNewsFieldModel[], value1: any, value2: any, fieldName: string) => {
        if (value1 !== value2) {
            editedNewsFields.push({
                id: 0,
                newsId: newsContext.news.id,
                userId: authContext.login.user.id,
                fieldName: fieldName,
                oldValue: (value1 != null ? value1.toString() : ''),
                newValue: (value2 != null ? value2.toString() : value2)
            });
        }
    };

    const createEditedNewsFieldJournalist = (editedNewsFields: EditedNewsFieldModel[], spreadsheetJournalist: string, currentJournalists: JournalistModel[], fieldName: string) => {

        const currentJournalistListContainsJournalist = (spreadsheetJournalist: string, currentJournalists: JournalistModel[]): boolean => {

            let found = false;

            for (let i = 0; i < currentJournalists.length; ++i) {
                if (spreadsheetJournalist && (spreadsheetJournalist.toLowerCase() === currentJournalists[i].name.toLowerCase())) {
                    found = true;
                    break;
                }
            }

            return found;
        };

        if (!currentJournalistListContainsJournalist(spreadsheetJournalist, currentJournalists)) {
            editedNewsFields.push({
                id: 0,
                newsId: newsContext.news.id,
                userId: authContext.login.user.id,
                fieldName: fieldName,
                oldValue: spreadsheetJournalist ? spreadsheetJournalist : '',
                newValue: currentJournalists.map(obj => obj.name).join(',')
            });
        }
    };

    const saveEditedNewsFields = (editedNewsFields: EditedNewsFieldModel[]) => {
        editedNewsFields.forEach((editedNewsField: EditedNewsFieldModel) => {
            EditedNewsFieldService.editedNewsFieldService(newsContext.news.id)
                .create(editedNewsField)
                .then(() => { ''; })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        });
    };

    const handleNewsToNotClassify = () => {
        if (spreadsheetId && newsContext.news.id) {
            setLoading(true);
            NewsService.updateStatusNews(spreadsheetId, newsContext.news.id, NewsStatus.NOT_CLASSIFY)
                .then(() => {
                    // fetchAllNews(() => {
                    //     if (newsContext.tabListSelected != 1)
                    //         newsContext.setNewsIndex(newsContext.newsIndex + 1);
                    // });
                })
                .catch((error: AxiosError) => { homeContext.showError('', error); })
                .finally(() => { setLoading(false); });
        }
    };

    const handleNewsToPending = () => {
        if (spreadsheetId && newsContext.news.id) {
            NewsService.updateStatusNews(spreadsheetId, newsContext.news.id, NewsStatus.PENDING)
                .then(() => {
                    // fetchAllNews(() => { fetchNews(); });                    
                })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        }
    };


    const getMessageNewsNotClassify = () => {
        return (
            <>
                {!loading && newsContext.listNewsPending.length > 0
                    && newsContext.news.id > 0
                    && newsContext.newsCurrentId
                    && newsContext.newsCurrentId > 0
                    && newsContext.news.status == NewsStatus.NOT_CLASSIFY
                    &&
                    <Grid
                        container
                        justify="center">
                        <Grid
                            container
                            spacing={4}
                            alignItems='center'
                            direction='row'
                            className={classes.gridContainerText}>
                            <Grid item xs={12} >
                                <Typography variant="h5" align="center" className={classes.text}>
                                    Esta notícia foi marcada por você como descartada.
                                </Typography>
                                <Typography variant="h6" align="center" className={classes.text}>
                                    Caso tenha mudado de ideia e queira classificá-la, basta clicar no botão abaixo.
                                </Typography>
                                <Grid container justify="center">
                                    <Button variant="outlined" onClick={handleNewsToPending}>
                                        Classificar notícia
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </>
        );
    };

    const getMessageNotNews = () => {
        return (
            <>
                {!loading && newsContext.listNewsPending.length > 0 && !newsContext.newsCurrentId &&
                    <Grid
                        container
                        justify="center">
                        <Grid
                            container
                            spacing={4}
                            alignItems='center'
                            direction='row'
                            className={classes.gridContainerText}>
                            <Grid item xs={12}>
                                <Typography variant="h5" align="center" className={classes.text}>
                                    Clique em um Influenciador no menu lateral esquerdo para classificá-lo.
                                </Typography>
                                <Typography variant="h6" align="center" className={classes.text}>
                                    Os campos para classificação aparecerão aqui.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </>
        );
    };

    const getNewsToClassify = () => {
        return (
            <>
                {!loading && newsContext.listNewsPending.length > 0
                    && newsContext.newsCurrentId
                    && newsContext.newsCurrentId > 0 &&
                    <Grid
                        container
                        justify="center"
                        alignItems="center">
                        <Grid
                            container
                            justify="center"
                            className={classes.gridContainer}
                            spacing={2}>
                            <Grid item xs={12} >
                                <Typography variant="h3" >
                                    Classificação do Influenciador
                                </Typography>
                            </Grid>
                            <Grid
                                container
                                justify="space-between"
                                className={classes.gridContainerClient}
                                spacing={2}>
                                <Typography variant="h4" color="textSecondary">
                                    {newsContext.news.nome}
                                </Typography>
                            </Grid>
                            <Grid
                                container
                                spacing={3}
                                direction="column"
                                alignItems="stretch"
                                justify="center"
                                className={classes.root}>
                                <Accordion defaultExpanded>
                                    <AccordionSummary expandIcon={<Icon className={'material-icons-round'}>expand_more</Icon>}>
                                        <Typography variant="h5">Dados do Influenciador</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <NewsData />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            <Grid
                                container
                                spacing={3}
                                direction="column"
                                alignItems="stretch"
                                justify="center"
                                className={classes.root}>
                                <Accordion defaultExpanded>
                                    <AccordionSummary expandIcon={<Icon className={'material-icons-round'}>expand_more</Icon>}>
                                        <Typography variant="h5">Categorização do Influenciador</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <NewsDataQuestions />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                            <Grid item>
                                <Grid container
                                    spacing={1}
                                    direction="column"
                                    alignItems="center"
                                    justify="center">
                                    {!(newsContext.news.id && newsContext.news.id > 0) &&
                                        <Grid item xs={12}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={newsContext.keepData}
                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => newsContext.setKeepData(event.target.checked)}
                                                        name="checkKeepData"
                                                        color="primary" />
                                                }
                                                label="Manter dados?" />
                                        </Grid>
                                    }
                                    {newsContext.news.id != ClassificationStatus.REMOVED && (
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleClickSave}
                                                    size="large"
                                                    fullWidth>
                                                    {'CLASSIFICAR'}
                                                </Button>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleClickCheck}
                                                    size="large"
                                                    fullWidth> {'Revisar'}
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </>
        );
    };

    return (
        <>
            <AppBar position="fixed" className={classes.toolbar} color='inherit' elevation={0}>
                <Grid container justify={openList ? 'flex-end' : 'space-between'}>
                    {!openList && (
                        <Button
                            className={classes.buttonsTop}
                            variant="text"
                            startIcon={<Icon color="primary">chevron_right</Icon>}
                            onClick={() => setOpenList(true)}>
                            Exibir lista de influenciadores
                        </Button>)
                    }
                    <Button
                        className={classes.buttonsTop}
                        variant="text"
                        onClick={() => {
                            if (!loading && newsContext.news.id > 0)
                                setShowConfirmExit(true);
                            else
                                homeContext.setPageLocation(PageLocation.INFLUENCER_HISTORY);
                        }}>
                        Ir para o histórico de planilhas
                    </Button>
                </Grid>
            </AppBar>
            {loading && <Grid container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.loading}>
                <CircularProgress color="primary" size="124px" />
            </Grid>}
            {getMessageNewsNotClassify()}
            {getMessageNotNews()}
            {getNewsToClassify()}
            <BasicConfirmDialog
                title="Sair sem salvar?"
                description="Ao sair sem salvar, você perderá todos os dados de classificação já preenchidos para esta publicação."
                handleFirstButton={() => homeContext.setPageLocation(PageLocation.INFLUENCER_HISTORY)}
                handleSecondButton={() => setShowConfirmExit(false)}
                textFirstButton="SAIR"
                textSecondButton="Permanecer na página"
                cssProperties={{
                    maxWidth: '550px'
                }}
                open={showConfirmExit} />
        </>
    );
}